/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContractDto } from '../../models/contract-dto';
import { ContractsForm } from '../../models/contracts-form';

export interface UpsertCustomerContract$Params {

/**
 * UUID to identify the svg (tenancy id)
 */
  svgId: string;

/**
 * UUID to identify the customer
 */
  customerId: string;

/**
 * product name to create/update contract
 */
  product: 'ASFINAG' | 'E_VIGNETTE' | 'FLEXBOX' | 'SATELLIC' | 'TOLL_COLLECT' | 'D_ESSO' | 'DKV' | 'DKV_BROKER_MODEL' | 'ESSO' | 'SHELL' | 'TOTAL' | 'ASD_OCCUPATIONAL_HEALTH' | 'ASD_OCCUPATIONAL_SAFETY' | 'DANGEROUS_GOODS' | 'DATA_PROTECTION' | 'ENVIRONMENTAL_SAFETY' | 'EPLAS' | 'FIRE_SAFETY' | 'OCCUPATIONAL_COMBI' | 'OCCUPATIONAL_HEALTH' | 'OCCUPATIONAL_SAFETY' | 'PROJECT_WORK' | 'QUALITY_MANAGEMENT' | 'RACK_INSPEKTION' | 'REPORTER' | 'WASTE_MANAGEMENT_OFFICER' | 'MINERAL_OIL_TAX_REFUND' | 'VAT_REFUND' | 'CONSULTING' | 'EXPERIENCE_EXCHANGE_FORUM' | 'SEMINAR';
      body: ContractsForm
}

export function upsertCustomerContract(http: HttpClient, rootUrl: string, params: UpsertCustomerContract$Params, context?: HttpContext): Observable<StrictHttpResponse<ContractDto>> {
  const rb = new RequestBuilder(rootUrl, upsertCustomerContract.PATH, 'put');
  if (params) {
    rb.path('svgId', params.svgId, {});
    rb.path('customerId', params.customerId, {});
    rb.path('product', params.product, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContractDto>;
    })
  );
}

upsertCustomerContract.PATH = '/svgs/{svgId}/customers/{customerId}/contracts/{product}/upsert';
